import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=429277c9&scoped=true&"
import script from "./PaymentButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentButton.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=429277c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429277c9",
  null
  
)

export default component.exports